@let hasPermission = caCloseAlert() | async;
@if (hasPermission === true) {
    <button mat-icon-button
            class="primary-icon"
            (click)="closeAlert()"
    >
        <mat-icon aria-label="close">notifications_off</mat-icon>
    </button>
}
